module.exports = __webpack_public_path__ + "img/stock-custom-1-.9dafb0d2.jpg";